import { render, staticRenderFns } from "./EditVideoDetails.vue?vue&type=template&id=38d8e08a&"
import script from "./EditVideoDetails.vue?vue&type=script&lang=js&"
export * from "./EditVideoDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports